import { Col, Form, Modal } from 'react-bootstrap';
import { createPortal } from 'react-dom';
import { useDispatch } from 'react-redux';
import { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { StepperComponent } from 'src/_metronic/assets/ts/components';
import { deleteTransactions } from './transactions-list/core/_requests';
import { setMessage } from 'src/store/alertMessage/actions';
import { useQueryResponse } from './transactions-list/core/QueryResponseProvider';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useQueryRequest } from './transactions-list/core/QueryRequestProvider';
type Props = {
  show: boolean;
  handleClose: () => void;
  id: any;
};

const modalsRoot = document.getElementById('root-modals') || document.body;

const Deleteparty = ({ show, handleClose, id }: Props) => {
  const intl = useIntl();
  const stepperRef = useRef<HTMLDivElement | null>(null);
  const stepper = useRef<StepperComponent | null>(null);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { refetch } = useQueryResponse();
  const { updateState } = useQueryRequest(); // Get updateState from useQueryRequest
  const [password, setPassword] = useState('');
  const passwordInputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    if (show) {
      setTimeout(() => {
        passwordInputRef.current?.focus();
      }, 100);
    }
  }, [show]);

  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement);
  };

  const [isDeleteConfirm, setDeleteConfirm] = useState(false);

  const enableDeleteLoading = () => {
    setDeleteConfirm(true);
  };

  const deleteAction = async () => {
    try {
      if (!id) {
        dispatch(setMessage('error', 'Transaction ID is missing!'));
        return;
      }
      if (!password.trim()) {
        dispatch(setMessage('error', 'Password is required'));
        return;
      }
      setLoading(true);
      const payload = { password: password.trim() || null };

      await deleteTransactions(id, payload)
        .then((data: any) => {
          if (data?.message) {
            dispatch(setMessage('success', data?.message));
            handleClose();
            refetch();
          } else {
            dispatch(setMessage('error', data?.message || 'Failed to delete transaction'));
          }
          setLoading(false);
          setPassword('');
        })
       
        .catch((error: any) => {
          console.error('Error deleting:', error);
          if (error?.response?.status === 400) {
            const errorData = error?.response?.data?.message;
    
           
    
            dispatch(setMessage("error", errorData));
          } else {
            
            dispatch(setMessage("error", error?.response?.data?.message || "An unexpected error occurred"));
          }
          setLoading(false);
        });
    } catch (err) {
      setLoading(false);
    }
  };

  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        deleteAction();
      }
    };

    if (show) {
      window.addEventListener('keydown', handleKeyPress);
    }

    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, [show, password]);

  // Modified onClose to reset to first page and refetch
  const onClose = () => {
    setPassword(''); // Reset password after deletion
    handleClose();
    // Reset pagination to page 1
    updateState({ page: 1 });
    // Refetch is not needed here because updateState triggers a query update
  };

  return createPortal(
    <Modal
      id="kt_modal_create_app"
      tabIndex={-1}
      aria-hidden="true"
      dialogClassName="modal-dialog modal-dialog-centered mw-450px delete-model"
      show={show}
      onHide={onClose} // Use the new onClose function
      onEntered={loadStepper}
      backdrop="static"
    >
      <div className="modal-body pt-10">
        {!isDeleteConfirm && (
          <>
            <div className="icon text-center">
              <div className="symbol symbol-65px symbol-circle symbol-icon text-center mb-10">
                <span className="symbol-label bg-danger">
                  <i className="fa-solid fa-trash fs-4 text-white fs-3"></i>
                </span>
              </div>
            </div>
            <p className="text-center mb-3 fs-5 fw-bold">Are you sure you want to delete?</p>
            <p className="text-center mb-5 fs-8">
              If you delete this transaction still you will find under
              <br />
              <Link to="/report/deleted-transactions" className="text-danger">
                Deleted Transactions Report
              </Link>
            </p>
            <Form.Control
              ref={passwordInputRef}
              tabIndex={1}
              type="password"
              className=""
              placeholder="Enter password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onClick={() => {
                setTimeout(() => {
                  passwordInputRef.current?.focus();
                }, 100);
              }}
            />
            <Col className="me-5 mt-10 text-center">
              <button
                type="button"
                className="btn btn-sm me-5 btn btn-danger"
                onClick={deleteAction}
                disabled={loading}
              >
                {loading
                  ? `${intl.formatMessage({ id: 'PLEASE.WAIT' })}`
                  : `${intl.formatMessage({ id: 'DELETE' })}`}
              </button>
              <button
                type="button"
                className="btn btn-sm btn btn-light btn-outline border-dark"
                onClick={onClose} // Use the new onClose function
                disabled={loading}
              >
                Cancel
              </button>
            </Col>
          </>
        )}
        {isDeleteConfirm && <div className="deletemessage">Party is removed from the system</div>}
      </div>
    </Modal>,
    modalsRoot
  );
};



export default Deleteparty;